import React, { useState } from "react";
import { IoIosSearch } from "react-icons/io";
import { useDispatch } from "react-redux";
import { GET_SEARCH_TICKER } from "../../../redux/types/analysis.types";
import { GiHamburgerMenu } from "react-icons/gi";
import { Drawer } from 'antd';
import SideBar from "../SideBar";

const Header = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState();
  const [open, setOpen] = useState(false);

  const handleSearch = (e) => {
    setSearch(e.target.value)
  }

  const getSearchTicker = (symbol) => {
    dispatch({ type: GET_SEARCH_TICKER, payload: { symbol } });
  }

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className="flex justify-between items-center gap-4 w-full px-4">
      <GiHamburgerMenu size={15} className="block md:hidden" onClick={showDrawer} />
      <Drawer
        title=""
        placement="left"
        closable={false}
        onClose={onClose}
        open={open}
      >
        <SideBar />
      </Drawer>
      <div className="h-auto w-[50%] py-4">
        <div className="flex items-center bg-[#F5F7F9] rounded-lg w-[80%] border-2 border-none ">
          <div className="px-2">
            <IoIosSearch color="#959798" size={24} />
          </div>
          <input
            className="bg-[#F5F7F9] w-[80%] py-3 px-16 pl-0  border-none outline-none"
            type="text"
            placeholder="Search for various bonds"
            onChange={handleSearch}
            value={search}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                getSearchTicker(search);
              }
            }}
          />
        </div>
      </div>
      <div className="flex justify-stretch gap-6 items-center w-[20%] py-4">
        <div>
          <img className="h-6" src="/img/notification.svg" alt="" />
        </div>
        <div className="border-r-2 border-black h-6"></div>
        <div>
          <img className="h-8" src="/img/profile.svg" alt="" />
        </div>
        <div className="text-black font-semibold">Aurobindo Gill</div>
      </div>
    </div>
  );
};

export default Header;
